import React from 'react';
import type {NextPage, NextPageContext} from 'next';

import {matchUrl} from './match-url';
import {Layout} from '../../components/layout';
import {NotFound} from '../../components/not-found';
import {NotFoundSeo} from '../seo';

type Guarded = {routeUnknown?: boolean};

/**
 * Обёртка для страниц-catch-all.
 *
 * Модуль ловит все адреса своего раздела, поэтому `/classes/что/угодно/глубокое`
 * дошёл бы до страницы и отрисовал пустоту. Если такого маршрута нет в таблице,
 * отдаём честную 404 — как это делал кастомный сервер.
 */
export function withKnownRoute<P extends object>(Page: React.ComponentType<P>): NextPage<P & Guarded> {
	const WithKnownRoute: NextPage<P & Guarded> = ({routeUnknown, ...props}) =>
		routeUnknown ? (
			<Layout>
				<NotFoundSeo />
				<NotFound />
			</Layout>
		) : (
			<Page {...(props as P)} />
		);

	WithKnownRoute.getInitialProps = async (ctx: NextPageContext) => {
		const known = !!matchUrl(ctx.asPath);
		if (!known && ctx.res) ctx.res.statusCode = 404;
		return {routeUnknown: !known} as P & Guarded;
	};

	WithKnownRoute.displayName = `withKnownRoute(${Page.displayName || Page.name || 'Page'})`;

	return WithKnownRoute;
}
